var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 9,
    viewBox: "0 0 29 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_223114)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8388 6.026C20.8448 4.651 19.7058 4.053 18.7948 3.576C18.1838 3.254 17.6758 2.987 17.6838 2.576C17.6908 2.263 17.9888 1.93 18.6388 1.846C19.4005 1.77266 20.1678 1.90636 20.8598 2.233L21.2558 0.387C20.5821 0.133713 19.8685 0.00265969 19.1488 0C16.9228 0 15.3568 1.183 15.3418 2.877C15.3278 4.13 16.4608 4.83 17.3138 5.247C18.1918 5.673 18.4858 5.947 18.4828 6.329C18.4828 6.914 17.7818 7.17 17.1348 7.181C16.0358 7.197 15.3848 6.893 14.8678 6.652L14.8218 6.631L14.4148 8.538C14.9408 8.779 15.9128 8.99 16.9188 9C19.2858 9 20.8328 7.831 20.8408 6.022L20.8388 6.026ZM11.5098 0.163L7.86078 8.869H5.47978L3.68378 1.92C3.57378 1.492 3.47978 1.336 3.14778 1.155C2.60778 0.861 1.71378 0.586 0.925781 0.415L0.978781 0.155H4.81178C5.06136 0.155885 5.30243 0.245811 5.49162 0.408598C5.6808 0.571385 5.80568 0.796345 5.84378 1.043L6.79178 6.075L9.13478 0.151L11.5098 0.163ZM28.7998 8.86H26.7178L26.4458 7.566H23.5568L23.0868 8.867H20.7218L24.1008 0.8C24.1778 0.608908 24.3103 0.445301 24.4813 0.33032C24.6522 0.215339 24.8538 0.154268 25.0598 0.155H26.9818L28.7998 8.86ZM24.2058 5.776L25.3918 2.508L26.0678 5.784L24.2058 5.776ZM12.8688 8.861L14.7308 0.155H12.4758L10.6128 8.86H12.8688V8.861Z",
    fill: "#122D98"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_223114"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVisa);
export default __webpack_public_path__ + "static/media/logo_visa.1c905d18f354aa2c146508e87caf87f0.svg";
export { ForwardRef as ReactComponent };